import apiClient from '../client';
import { SiteConfig } from '../types';

export const siteApi = {
  getConfig: async (): Promise<SiteConfig> => {
    const response = await apiClient.get<SiteConfig>('/site/config/');
    return response.data;
  },
};

export default siteApi;
